// extracted by mini-css-extract-plugin
export var background_wrapper = "top_banner-module--background_wrapper--ietIX";
export var background_wrapper_custom_img = "top_banner-module--background_wrapper_custom_img--Gx8xP";
export var button1 = "top_banner-module--button1--2POKM";
export var description = "top_banner-module--description--Mtz+Z";
export var leftHalfWrapper = "top_banner-module--leftHalfWrapper--o0WI7";
export var rightHalfWrapper = "top_banner-module--rightHalfWrapper--tGSyW";
export var title = "top_banner-module--title--JRZ67";
export var wrapper = "top_banner-module--wrapper--+mP7X";